import { BaseText, H3 } from '@/shared/components/StyledText';
import { green } from '@/shared/styles/colors';
import styled from '@emotion/native';

export const Title = styled(H3)({
  textTransform: 'uppercase',
  maxWidth: '100%',
  marginBottom: 12,
  color: green,
  textAlign: 'center',
});

export const SubheaderText = styled(BaseText)({
  fontSize: 16,
  letterSpacing: -0.16,
  textAlign: 'center',
  marginBottom: 30,
});

export const FieldLabel = styled(BaseText)({
  fontSize: 16,
  marginBottom: 8,
});

export const OptionFooterText = styled(BaseText)({
  fontSize: 14,
  fontStyle: 'italic',
  marginBottom: 24,
});
